<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » プロジェクト：編集の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>プロジェクト：編集の説明</span></mat-card-title>
    </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/top-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、修正した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          該当プロジェクトのIDが表示されます。<br>
          編集はできません。
        </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/C.png"> 名称
      </div>
      <div class="manual-explain">
        該当プロジェクトの名称を設定します。<br>
        <span class="manual-explain-notes">※必須項目</span>
      </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 備考
        </div>
        <div class="manual-explain">
          該当プロジェクトの備考を設定します。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 施設登録限度数
        </div>
        <div class="manual-explain">
          該当プロジェクトの施設登録限度数が表示されます。<br>
          編集はできません。施設登録限度数を変更したい場合は、弊社担当へご連絡下さい。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 番号入力タイプ
        </div>
        <div class="manual-explain">
          ユーザーシステム「番号入力」時に表示するソフトウェアキーボードタイプを設定します。<br>
          「半角数字」か「半角英数＋ハイフン」のいずれかを選択します。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> 翻訳基本言語
        </div>
        <div class="manual-explain">
          翻訳の元となる言語を設定します。<br>
          「英語（イギリス）」か「英語（アメリカ）」のいずれかを選択します。<br>
          ※翻訳は、翻訳用（日本語）から英語（ここで設定したもの）に翻訳され、その後、英語（ここで設定したもの）から各言語に翻訳されます。
        </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/G.png"> 翻訳方法の選択
      </div>
      <div class="manual-explain">
        テキストの自動翻訳時に韓国語と中国語は日本語から直接翻訳されます。<br>
        日本語からの直接翻訳ではなく、翻訳基本言語「英語（イギリス）」か「英語（アメリカ）」を介して翻訳したい場合はチェックを入れます。<br>
        チェックを入れるとドイツ語などの他言語と同様に、日本語→翻訳基本言語「英語（イギリス）」か「英語（アメリカ）」→各言語の形で自動翻訳します。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/I.png"> 使用言語一覧
      </div>
      <div class="manual-explain">
        該当プロジェクトで使用する言語が一覧表示されます。<br>
        言語追加ボタンから使用言語を追加可能です。<br>
        言語をドラッグすることで並び順を変更できます。並び順はユーザ画面に影響します。<br>
        また、話者について言語ごとに男性、女性の変更（一部言語を除く）が可能です。<br>
        <span class="manual-explain-notes">※必須項目。１つ以上の言語を選択して下さい。</span>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/J.png"> 更新ボタン
      </div>
      <div class="manual-explain">
        クリックすることで編集内容が更新されます。
      </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Usage Top</a> » Project: Edit Description
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Project: Edit Description</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_top-dialog.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any changes made will not be saved.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          Displays the ID of the relevant project.<br>
          Editing is not allowed.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Project Name
        </div>
        <div class="manual-explain">
          Sets the project name of the relevant project.<br>
          <span class="manual-explain-notes">※Required field</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Notes
        </div>
        <div class="manual-explain">
          Sets notes for the relevant project.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Facility Registration Limit
        </div>
        <div class="manual-explain">
          Displays the facility registration limit for the relevant project.<br>
          Editing is not allowed. To change the facility registration limit, please contact our representative.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Number Input Type
        </div>
        <div class="manual-explain">
          Sets the type of software keyboard displayed during "Number Input" in the user system.<br>
          Choose either "Half-width Numbers" or "Half-width Alphanumeric + Hyphen".
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> Base Translation Language
        </div>
        <div class="manual-explain">
          Sets the base language for translations.<br>
          Choose either "English (UK)" or "English (US)".<br>
          ※Translations will first be made from Translation Base (Japanese) to English (as set here), and then from English (as set here) to other languages.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/H.png"> List of Used Languages
        </div>
        <div class="manual-explain">
          Displays a list of languages used in the project.<br>
          Additional languages can be added using the "Add Language" button.<br>
          You can reorder the languages by dragging them. The order will affect the user interface.<br>
          Additionally, you can change the speaker (male or female) for each language (except for some languages).<br>
          <span class="manual-explain-notes">※Required field. Please select at least one language.</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/I.png"> Update Button
        </div>
        <div class="manual-explain">
          Click to save the changes made.
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>
